<svg-icon
  [style.width.px]="size()"
  [style.height.px]="size()"
  [src]="name() ? undefined : source()"
  [name]="name()"
></svg-icon>
